import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl"
  className?: string
}

export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-8 w-8 border-2",
    lg: "h-12 w-12 border-[3px]",
    xl: "h-16 w-16 border-4",
  }

  return (
    <div
      className={cn(
        "inline-block rounded-full border-solid",
        "border-border dark:border-border/50",
        "border-t-primary",
        "animate-spin",
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Carregando"
    >
      <span className="sr-only">Carregando...</span>
    </div>
  )
}

interface LoadingPageProps {
  message?: string
  fullScreen?: boolean
}

export function LoadingPage({ message = "Carregando...", fullScreen = true }: LoadingPageProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4",
        fullScreen && "min-h-screen"
      )}
    >
      <LoadingSpinner size="lg" />
      <p className="text-muted-foreground dark:text-muted-foreground text-sm font-medium">{message}</p>
    </div>
  )
}

interface LoadingOverlayProps {
  message?: string
  show?: boolean
}

export function LoadingOverlay({ message = "Carregando...", show = true }: LoadingOverlayProps) {
  if (!show) return null

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white/80 dark:bg-background/80 backdrop-blur-sm rounded-lg z-50">
      <LoadingSpinner size="md" />
      {message && (
        <p className="text-muted-foreground dark:text-muted-foreground text-sm font-medium">{message}</p>
      )}
    </div>
  )
}

interface LoadingButtonProps {
  loading?: boolean
  children: React.ReactNode
  className?: string
}

export function LoadingButton({ loading, children, className }: LoadingButtonProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {loading && <LoadingSpinner size="sm" />}
      <span>{children}</span>
    </div>
  )
}
